export type DatabaseColumn = {
	name?: string;
	type?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type DatabaseFunction = {
	name?: string;
	schema?: string;
	parameters?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type DatabaseProcedure = {
	name?: string;
	schema?: string;
	parameters?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type DatabaseTable = {
	name?: string;
	schema?: string;
	columns?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type Accounting = {
	id_server?: number;
	hidden?: boolean;
	accounting?: number;
	accounting_parent?: number;
	company_parent?: string;
	id_accounting_group?: number;
	group_name?: string;
	company?: string;
	super_db_name?: string;
	master_db_name?: string;
	master_db_name_2?: string;
	reporting_db_name?: string;
	reporting_db_name_2?: string;
	data_db_name?: string;
	data_db_name_2?: string;
	mdm_db_name?: string;
	mdm_db_name_2?: string;
	fin_flag?: boolean;
	item_flag?: boolean;
	balance_flag?: boolean;
	fin_module_name?: string;
	item_module_name?: string;
	balance_module_name?: string;
	etl_db_user?: string;
	etl_db_password?: string;
	etl_dir?: string;
	id_logo?: number;
	logo_url?: string;
	mail_helpdesk?: string;
	mail_etl?: string;
	mail_etl_file?: string;
	item_balance_calculation?: string;
	uid?: string;
	fin_report_period?: boolean;
	fin_begin_month?: number;
	accounting_system?: string;
	helios_guid?: string;
	helios_version?: string;
	helios_params?: string;
	date_activated?: string;
	level?: number;
	md_table?: string;
	job_name?: string;
	cache?: boolean;
	remark?: string;
	remark_type?: string;
	fin_updated?: string;
	fin_remark?: string;
	fin_remark_type?: string;
	item_updated?: string;
	item_remark?: string;
	item_remark_type?: string;
	balance_updated?: string;
	balance_remark?: string;
	balance_remark_type?: string;
	db_server_name?: string;
	app_server_name?: string;
	access_role?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type AccountingGroup = {
	id_group?: number;
	id_accounting?: string;
	group_name?: string;
	login_limit?: number;
	user_count?: number;
	show_all_users?: boolean;
	user_domain?: string;
	custom_domain?: string;
	custom_login?: boolean;
	custom_login_id_image?: number;
	custom_login_style?: string;
	custom_id_favicon?: number;
	enable_permanent_login?: boolean;
	enable_captcha?: boolean;
	password_complexity?: number;
	disable_password_change?: boolean;
	disable_ai?: boolean;
	sso?: boolean;
	disable_manual_login?: boolean;
	sso_saml2?: boolean;
	login_max_attempts?: number;
	login_attempts_timeout?: number;
	ip_filter?: string;
	sanitized_name?: string;
	sso_key?: string;
	sso_session_expiration?: number;
	sso_saml2_idp_metadata_url?: string;
	sso_saml2_sp?: string;
	sso_saml2_idp?: string;
	sso_saml2_security?: string;
	sso_saml2_transform?: string;
	sso_oidc?: boolean;
	sso_oidc_issuer?: string;
	sso_oidc_client_id?: string;
	sso_oidc_client_secret?: string;
	sso_oidc_settings?: string;
	sso_oidc_preset?: number;
	helios_sn?: string;
	helios_licence_count?: number;
	encryption?: boolean;
	encryption_aes_key?: string;
	date_activated?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type AccountingOptions = {
	accounting?: number;
	date_format?: string;
	date_format_month?: string;
	fin_account_attributes?: PropertiesDefinition[];
	fin_custom_detail?: CustomDetailDefinition[];
	item_custom_detail?: CustomDetailDefinition[];
	invoice_custom_detail?: CustomDetailDefinition[];
	number_item_dim?: number;
	number_item_kpi?: number;
	item_text_attributes?: PropertiesDefinition[];
	item_columns?: DrillColumnDefinition[];
	fin_text_attributes?: PropertiesDefinition[];
	fin_columns?: DrillColumnDefinition[];
	invoice_text_attributes?: PropertiesDefinition[];
	invoice_columns?: DrillColumnDefinition[];
	company?: string;
	export_limit_timeout?: number;
	export_limit_rows_daily?: number;
	export_limit_size_daily?: number;
	export_limit_time_daily?: number;
}

export type AccountingSettings = {
	tree?: string;
	options?: AccountingOptions;
	id_group?: number;
	group_name?: string;
	group_date_activated?: string;
	group_disable_ai?: boolean;
	helios_sn?: string;
	helios_licence_count?: number;
	accounting_count?: number;
	user_count?: number;
	max_user_count?: number;
	login_limit?: number;
	user_domain?: string;
	host?: string;
	has_uid?: boolean;
	is_admin?: boolean;
	id_server?: number;
	hidden?: boolean;
	accounting?: number;
	accounting_parent?: number;
	company_parent?: string;
	id_accounting_group?: number;
	company?: string;
	super_db_name?: string;
	master_db_name?: string;
	master_db_name_2?: string;
	reporting_db_name?: string;
	reporting_db_name_2?: string;
	data_db_name?: string;
	data_db_name_2?: string;
	mdm_db_name?: string;
	mdm_db_name_2?: string;
	fin_flag?: boolean;
	item_flag?: boolean;
	balance_flag?: boolean;
	fin_module_name?: string;
	item_module_name?: string;
	balance_module_name?: string;
	etl_db_user?: string;
	etl_db_password?: string;
	etl_dir?: string;
	id_logo?: number;
	logo_url?: string;
	mail_helpdesk?: string;
	mail_etl?: string;
	mail_etl_file?: string;
	item_balance_calculation?: string;
	uid?: string;
	fin_report_period?: boolean;
	fin_begin_month?: number;
	accounting_system?: string;
	helios_guid?: string;
	helios_version?: string;
	helios_params?: string;
	date_activated?: string;
	level?: number;
	md_table?: string;
	job_name?: string;
	cache?: boolean;
	remark?: string;
	remark_type?: string;
	fin_updated?: string;
	fin_remark?: string;
	fin_remark_type?: string;
	item_updated?: string;
	item_remark?: string;
	item_remark_type?: string;
	balance_updated?: string;
	balance_remark?: string;
	balance_remark_type?: string;
	db_server_name?: string;
	app_server_name?: string;
	access_role?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type AppInfo = {
	name?: string;
	abbreviation?: string;
	icon?: string;
	color?: string;
	description?: string;
}

export type Application = {
	accounting?: number;
	scope_group?: number;
	company?: string;
	id_application?: number;
	name?: string;
	client_id?: string;
	client_secret?: string;
	client_secret_plain?: string;
	requires_user?: boolean;
	scope?: string;
	redirect_uri?: string;
	scope_array?: string[];
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type CustomDetailDefinition = {
	name?: string;
	id_custom_resource?: number|string;
	id_statement?: number|string;
}

export type DrillColumnDefinition = {
	name?: string;
	hidden?: boolean;
	ord?: number;
	description?: string;
}

export type ErrorEntity = {
	idz?: number;
	user_name?: string;
	accounting?: number;
	message?: string;
	content?: string;
	has_content?: boolean;
	priority?: string;
	url?: string;
	domain?: string;
	server?: string;
	ip?: string;
	user_agent?: string;
	date_created?: string;
}

export type File = {
	id_file?: number;
	accounting?: number;
	id_accounting_group?: number;
	user_name?: string;
	filename?: string;
	content?: string;
	content_base64?: string;
	size?: number;
	mime_type?: string;
	scope?: string;
	thumbnail?: string;
	extension?: string;
	dir?: string;
	orig_filename?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type HistoryItem = {
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	who_created_dv?: string;
	date_deleted?: string;
	who_deleted?: string;
	description?: string;
}

export type ListItem = {
	k?: string;
	v?: string;
	l?: number;
	count?: number;
}

export type ObjectShare = {
	accounting?: number;
	only_share?: boolean;
	object?: string;
	id_object?: string;
	accounting_share?: number;
	id_share_object?: string;
	name_share?: string;
	name?: string;
	company?: string;
	who_created_dv?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type PropertiesDefinition = {
	key?: string;
	name?: string;
	type?: string;
	format?: string;
}

export type Server = {
	idz?: number;
	id_server?: number;
	host?: string;
	db_user?: string;
	db_password?: string;
	db_name?: string;
	network_path?: string;
	network_user?: string;
	network_password?: string;
	linked_server_name?: string;
	etl_base_path?: string;
	url?: string;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export type User = {
	user_name?: string;
	login_name?: string;
	password_hash?: string;
	last_accounting?: number;
	rights?: string;
	tfa_secret?: string;
	tfa_method?: number;
	lang?: string;
	password_change_token?: string;
	id_accounting_group?: number;
	password?: string;
	login_name_2?: string;
	email?: string;
	phone?: string;
	last_login?: string;
	disabled?: boolean;
	user_groups?: string;
	display_user_groups?: string;
	accounting_groups?: string;
	display_accounting_groups?: string;
	domain_login_name?: string;
	idz?: number;
	validate_flag?: boolean;
	date_created?: string;
	who_created?: string;
	date_deleted?: string;
	who_deleted?: string;
}

export enum AccountingRights {
	Finance = 'finance',
	FinanceRead = 'finance.read',
	Items = 'items',
	ItemsRead = 'items.read',
	Aging = 'aging',
	AgingRead = 'aging.read',
	Definition = 'definition',
	Admin = 'admin',
	MDMRead = 'mdm.read',
	MDMWrite = 'mdm.write',
	MDMDefine = 'mdm.define',
	ETL = 'etl',
	Custom = 'custom',
	CustomDefine = 'custom.define',
	CFM = 'cfm',
	Helpdesk = 'helpdesk',
	WikiWrite = 'wiki.write',
	IOImport = 'io.import',
	IOExport = 'io.export',
	IODelete = 'io.delete',
	JobsRead = 'jobs.read',
	JobsDefine = 'jobs.define',
	DWHRead = 'dwh.read',
	DWHWrite = 'dwh.write',
	AI = 'ai',
}

export enum GlobalRights {
	SA = 'sa',
	Owner = 'owner',
	NoCount = 'nocount',
	Deployment = 'deployment',
	DeploymentRead = 'deployment.read',
	Dev = 'dev',
}